function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d7282f;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.5 -23.15)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.5 23.15)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M78.874,72.15H67.818a.719.719,0,0,0-.718.718v7.308a.719.719,0,0,0,.718.718H78.874a.719.719,0,0,0,.718-.718V72.868A.719.719,0,0,0,78.874,72.15ZM68.537,79.458V73.587h9.619v5.871Z",
  transform: "translate(-62.815 -69.089)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M27.775,48.634H17.4V38.828h.924A1.576,1.576,0,0,1,19.9,40.414v1.743a3.4,3.4,0,0,0,6.808,0V32.276a4.151,4.151,0,0,0-1.1-2.829l-4.946-5.636-1.078.948,3.74,4.265a2.606,2.606,0,0,0,.6,5.144,2.657,2.657,0,0,0,1.354-.382v8.371a1.968,1.968,0,0,1-3.935,0v-1.73a3.022,3.022,0,0,0-3-3.036H17.4V25.848a2.686,2.686,0,0,0-2.667-2.7H3.128a2.68,2.68,0,0,0-2.655,2.7V48.634H-.782a.719.719,0,0,0-.718.718.719.719,0,0,0,.718.718H27.782a.718.718,0,1,0-.006-1.437Zm-25.865,0V25.848a1.242,1.242,0,0,1,1.218-1.262H14.734a1.248,1.248,0,0,1,1.23,1.262V48.634ZM25.083,31.557a1.168,1.168,0,1,1-1.168-1.168A1.169,1.169,0,0,1,25.083,31.557Z",
  transform: "translate(1.5 -23.15)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.03 37.412)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M122.544,251.764a.756.756,0,0,0-1.163,0c-.218.363-2.326,3.562-2.326,5.378a2.911,2.911,0,1,0,5.814,0C124.87,255.326,122.834,252.127,122.544,251.764Zm-.581,6.978a1.541,1.541,0,0,1-1.454-1.6,9.637,9.637,0,0,1,1.454-3.561,9.635,9.635,0,0,1,1.454,3.561A1.541,1.541,0,0,1,121.962,258.742Z",
  transform: "translate(-119.055 -251.492)"
}))));

var SvgFuelLevel = function SvgFuelLevel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26.921,
    viewBox: "0 0 30 26.921",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFuelLevel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fuel-level.495868d3.svg";
export { ForwardRef as ReactComponent };